import { AxiosError, AxiosResponse } from "axios";
import { clearAuthData } from "../auth-utils";
import { AuthRedirectService } from "../../services/auth-redirect-service";
import { ResponseInterceptor } from "../types/http-types";

// Flag to prevent multiple sign-outs (extracted from api-client.ts)
let isSigningOut = false;

/**
 * Error Response Interceptor
 * Handles HTTP error responses with authentication logic
 * Follows SRP: Single responsibility - error handling only
 */
export class ErrorInterceptor implements ResponseInterceptor {
  /**
   * Pass through successful responses unchanged
   */
  onResponse(response: AxiosResponse): AxiosResponse {
    return response;
  }

  /**
   * Handle HTTP error responses
   * Maintains exact same logic as original api-client.ts
   */
  async onResponseError(error: AxiosError): Promise<never> {
    const requestUrl = error.config?.url || "Unknown URL";

    if (error.response?.status === 401) {
      console.error(
        `[HTTP Error Interceptor] Unauthorized request to ${requestUrl}`
      );

      if (typeof window !== "undefined" && !isSigningOut) {
        isSigningOut = true;
        // Clear auth data and redirect using utility function
        clearAuthData();
        AuthRedirectService.redirectToRoot();
        return new Promise(() => {});
      }
    }

    return Promise.reject(error);
  }

  /**
   * Reset flags - useful for testing or manual reset
   */
  static resetFlags(): void {
    isSigningOut = false;
  }
}

/**
 * Singleton instance for use across HTTP clients
 */
export const errorInterceptor = new ErrorInterceptor();
